module.exports = __webpack_public_path__ + "static/media/times-octagon.d819ab06.svg";